import utils from '@/mixins/utils'

/**
 * Filtra os dados
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object} selectedFilterBoasPraticas
 * @returns {Array}
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterBoasPraticas
) {
  let cadastros_filtrados = cadastros

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    if (exibirVermelhos === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp < 100 && item.total_bp_filtro < 100) ||
          (item.proxima_consulta == null && item.parto == null)
        ) {
          item.rowColor = 'red'
          return true
        }
        return false
      })
    } else if (exibirVerdes === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp == 100 || item.total_bp_filtro == 100) &&
          (item.proxima_consulta != null || item.parto != null)
        ) {
          item.rowColor = 'green'
          return true
        }
        return false
      })
    } else {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp == 100 || item.total_bp_filtro == 100) &&
          (item.proxima_consulta != null || item.parto != null)
        ) {
          item.rowColor = 'green'
        } else {
          item.rowColor = 'red'
        }
        return true
      })
    }
  } else {
    cadastros_filtrados = filterByBoaPratica(
      cadastros_filtrados,
      selectedFilterBoasPraticas,
      exibirVermelhos,
      exibirVerdes
    )
  }

  return cadastros_filtrados
}

/**
 * Filtra os dados das puérperas
 *
 * @param {Array} cadastros
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @param {Object} selectedFilterBoasPraticas
 * @returns {Array}
 */
export function filtroPuerperas(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterBoasPraticas
) {
  let cadastros_filtrados = cadastros

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    if (exibirVermelhos === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp < 100 && item.total_bp_filtro < 100) ||
          (item.proxima_consulta == null && item.parto == null)
        ) {
          item.rowColor = 'red'
          return true
        }
      })
    } else if (exibirVerdes === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp == 100 || item.total_bp_filtro == 100) &&
          (item.proxima_consulta != null || item.parto != null)
        ) {
          item.rowColor = 'green'
          return true
        }
      })
    } else {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (
          (item.total_bp == 100 || item.total_bp_filtro == 100) &&
          (item.proxima_consulta != null || item.parto != null)
        ) {
          item.rowColor = 'green'
        } else {
          item.rowColor = 'red'
        }
        return true
      })
    }
  } else {
    cadastros_filtrados = filterByBoaPratica(
      cadastros_filtrados,
      selectedFilterBoasPraticas,
      exibirVermelhos,
      exibirVerdes
    )
  }

  return cadastros_filtrados
}

/**
 * Filtra por boa prática
 *
 * @param {Array} cadastros
 * @param {Object} bp
 * @param {Boolean} exibirVermelhos
 * @param {Boolean} exibirVerdes
 * @returns {Array}
 */
function filterByBoaPratica(cadastros, bp, exibirVermelhos, exibirVerdes) {
  const regras = {
    'primeira-consulta': { campo: 'a_pb' },
    consultas: { campo: 'b_pb' },
    'afericao-pa': { campo: 'c_pb' },
    'peso-altura': { campo: 'd_pb' },
    visitas: { campo: 'e_pb', regraExtra: (el) => el.tp_ine_fci !== '76' },
    vacinas: { campo: 'f_pb', regraExtra: (el) => el.ig_atual >= 20 },
    'primeiro-trimestre': { campo: 'g_pb' },
    'terceiro-trimestre': {
      campo: 'h_pb',
      regraExtra: (el) => el.trimestre >= 3,
    },
    'consulta-puerperal': {
      campo: 'i_pb',
      regraExtra: (el) => el.ainda_gestante == 0,
    },
    'visita-puerperio': {
      campo: 'j_pb',
      regraExtra: (el) => el.ainda_gestante == 0 && el.tp_ine_fci != '76',
    },
    'avaliacao-odonto': { campo: 'k_pb' },
  }

  const regra = regras[bp?.key]
  if (!regra) return cadastros

  return cadastros.filter((el) => {
    const valor = Number(el?.[regra.campo])

    // aplica regra extra se houver
    if (regra.regraExtra && !regra.regraExtra(el)) {
      return false
    }

    // vermelho
    if (exibirVermelhos) {
      if (valor == null || valor === 0) {
        el.rowColor = 'red'
        return true
      }
      return false
    }

    // verde
    if (exibirVerdes) {
      if (valor != null && valor > 0) {
        el.rowColor = 'green'
        return true
      }
      return false
    }

    // neutro: considera válido se valor > 0
    if (valor != null && valor > 0) {
      el.rowColor = 'green'
      return true
    }

    el.rowColor = 'red'
    return true
  })
}
